export default __webpack_public_path__ + "static/media/fuel_station.2a4dbe63.png";